module.exports = __webpack_public_path__ + "assets/img/btn-info-a121f312.png";